/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DefinedTermStyle {
    Lowercase = 'Lowercase',
    Uppercase = 'Uppercase',
    PascalCase = 'PascalCase'
}

export function DefinedTermStyleFromJSON(json: any): DefinedTermStyle {
    return DefinedTermStyleFromJSONTyped(json, false);
}

export function DefinedTermStyleFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinedTermStyle {
    return json as DefinedTermStyle;
}

export function DefinedTermStyleToJSON(value?: DefinedTermStyle | null): any {
    return value as any;
}

